import React, { useState } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js';
import { sortPersonalScores } from "../utilities";
import { Link } from 'react-router-dom';
import 'chartjs-adapter-date-fns';

// Register necessary components for Chart.js
Chart.register(...registerables);

export function PersonalScoreboardView(props) {
    const [activeTab, setActiveTab] = useState('table');

    const sortedScores = sortPersonalScores(props.personalScores);

    // Filter out undefined scores
    const filteredScores = sortedScores.filter(score => score.score !== undefined);

    const chartData = {
        labels: filteredScores.map(score => score.date ? new Date(score.date) : null),
        datasets: [
            {
                label: 'Score Over Time',
                data: filteredScores.map(score => score.score),
                borderColor: 'rgba(75, 192, 192, 1)',
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                fill: false,
                tension: 0.1,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                type: 'time',
                time: {
                    unit: 'day',
                    tooltipFormat: 'yyyy-MM-dd',
                    displayFormats: {
                        day: 'yyyy-MM-dd',
                    },
                },
                title: {
                    display: true,
                    text: 'Date',
                },
            },
            y: {
                title: {
                    display: true,
                    text: 'Score',
                },
                beginAtZero: true,
            },
        },
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    return (
        <div>
            <div className='w-full h-full flex items-center justify-center'>
                <div className='flex flex-col items-center justify-start w-4/5 bg-gray-800 p-6 rounded-lg shadow-lg'>
                    <h1 className='text-3xl mb-10 text-white'>Personal Scoreboard</h1>
                    <div className='flex justify-center mb-4'>
                    <button
                            className={`mx-2 px-4 py-2 focus:outline-none ${activeTab === 'table' ? 'bg-gray-700 text-white' : 'bg-gray-400 text-gray-800'}`}
                            style={activeTab === 'table' ? { textDecoration: 'underline', textDecorationColor: 'rgba(75, 192, 192, 1)', textUnderlineOffset: '4px', textDecorationThickness: '2px' } : {}}
                            onClick={() => handleTabChange('table')}
                        >
                            Table
                        </button>
                        <button
                            className={`mx-2 px-4 py-2 focus:outline-none ${activeTab === 'chart' ? 'bg-gray-700 text-white' : 'bg-gray-400 text-gray-800'}`}
                            style={activeTab === 'chart' ? { textDecoration: 'underline', textDecorationColor: 'rgba(75, 192, 192, 1)', textUnderlineOffset: '4px', textDecorationThickness: '2px' } : {}}
                            onClick={() => handleTabChange('chart')}
                        >
                            Chart
                        </button>
                    </div>
                    {activeTab === 'table' ? (
                        <table className='w-full bg-gray-700 text-gray-100 border border-gray-600 rounded-lg shadow-md'>
                            <thead className='bg-gray-600'>
                                <tr>
                                    <th className='px-4 py-2 text-gray-100'>No</th>
                                    <th className='px-4 py-2 text-gray-100'>Points</th>
                                    <th className='px-4 py-2 text-gray-100'>Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sortedScores.map((personalScore, index) => (
                                    <tr key={personalScore.id} className='hover:bg-gray-600 border-b border-gray-500'>
                                        <td className='px-4 py-2 text-gray-100 text-center'>{index + 1}.</td>
                                        <td className='px-4 py-2 text-gray-100 text-center'>{personalScore.score} p</td>
                                        <td className='px-4 py-2 text-gray-100 text-center'>{personalScore.date ? new Date(personalScore.date).toLocaleDateString() : 'N/A'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div className='w-full bg-gray-700 text-gray-100 border border-gray-600 rounded-lg shadow-md p-4'>
                            <div style={{ height: '400px', width: '100%' }}>
                                <Line data={chartData} options={chartOptions} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="flex flex-wrap justify-center mt-10">
                <Link className="btn-primary mb-4 w-72 md:mx-4 text-center" to="/">
                    Home
                </Link>
                <Link className="btn-secondary mb-4 w-72 md:mx-4" to="/generalScoreboard">
                    General Scoreboard
                </Link>
            </div>
        </div>
    );
}

export default PersonalScoreboardView;
